<template>
  <transition name="btt">
    <button
      v-show="show"
      class="btt"
      type="button"
      aria-label="回到顶部"
      title="回到顶部"
      @click="toTop"
    >
      <span class="btt__arrow"></span>
    </button>
  </transition>
</template>

<script>
export default {
  name: 'BackToTop',
  data () {
    return { show: false }
  },
  mounted () {
    window.addEventListener('scroll', this.onScroll, true)
    this.onScroll()
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.onScroll, true)
  },
  methods: {
    onScroll () {
      const top = window.pageYOffset || document.documentElement.scrollTop || 0
      this.show = top > 600
    },
    toTop () {
      // 产品页用 GSAP ScrollTrigger 钉住了区块，平滑滚动会和它抢滚动位置，
      // 所以这里直接跳到顶部
      window.scrollTo(0, 0)
      document.documentElement.scrollTop = 0
      document.body.scrollTop = 0
    }
  }
}
</script>

<style scoped lang="less">
.btt {
  position: fixed;
  right: 30px;
  bottom: 60px;
  z-index: 1200;
  width: 46px;
  height: 46px;
  border: none;
  border-radius: 50%;
  background: rgba(12, 128, 102, 0.9);
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.22);
  cursor: pointer;
  transition: background 0.25s, transform 0.25s;
  &:hover {
    background: #0c8066;
    transform: translateY(-3px);
  }
}
.btt__arrow {
  display: block;
  width: 11px;
  height: 11px;
  margin: 3px auto 0;
  border-left: 2px solid #fff;
  border-top: 2px solid #fff;
  transform: rotate(45deg);
}
.btt-enter-active, .btt-leave-active { transition: opacity 0.25s; }
.btt-enter, .btt-leave-to { opacity: 0; }
</style>
